import initTopicFilterSection from "../initTopicFilterSection.js";

document.addEventListener("DOMContentLoaded", () => {
  initTopicFilterSection();
});
